define('../src/sublayouts/m6-contact-us/m6-contact-us',['jquery'], function($) {

    'use strict';

    var M6_Contact = function($component) {

        this.$component = $component;

        window.MAP = this;

        return this;
    };

    /**
     * Initialize component
     */

    M6_Contact.prototype.init = function() {
        var _this = this,
            lang = ($('html').attr('dir') == 'rtl') ? 'ar' : 'en',
            script = document.createElement( 'script' ),
            url = 'https://maps.googleapis.com/maps/api/js?libraries=places,geometry&v=3&key=AIzaSyD3S3q5M76YS9fx9vCM7Mmk2NNLGT0A1nk&language=' + lang;
        
        script.type = 'text/javascript';
        script.src = url +
            '&callback=initializeGMap';
        
        document.body.appendChild( script );

    };

    window.initializeGMap = function initializeGMap() {
        var mapDiv = document.getElementById('m6-contact-us_map'),
            latlng = JSON.parse($('.m6-contact-us').attr('data-coord'));

        window.map = new google.maps.Map(mapDiv, {
            center: new google.maps.LatLng(latlng.lat, latlng.lng),
            zoom: 15,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            navigationControl: true,
            navigationControlOptions: {
                style: google.maps.NavigationControlStyle.SMALL
            },
            mapTypeControl: false,
            streetViewControl: false
        });

        var myLatLng = { lat: latlng.lat, lng: latlng.lng };

        var service = new google.maps.places.PlacesService(map);

        var pin = new google.maps.Marker({
            map: window.map,
            position: myLatLng,
            icon: $('.m6-contact-us').attr('data-pin')
        });

        google.maps.event.addDomListener(window, 'resize', function() {
            map.setCenter(myLatLng);
        });
    };

    return M6_Contact;
});

